const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhysiotherapy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    className: "appointment-types__type-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 38.82 41.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.22,12.55A17.15,17.15,0,0,1,1.64,8.67,1,1,0,1,0,.27,10a19.86,19.86,0,0,0,8,4.59",
    style: {
      fill: "#9d9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.43,20.75c.48-3.39.86-6.17.9-6.44,0-.05,0-.09,0-.13a5.64,5.64,0,0,0-2.17-4.43l-.06-.05L19.65,7l-2.56.4,4.81,3.79a3.82,3.82,0,0,1,1.53,2.95c-.07.51-.53,3.87-1.07,7.67",
    style: {
      fill: "#9d9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.42,24.17a18.36,18.36,0,0,0,.37,3.2,19.56,19.56,0,0,1,.38,6.29l-.4,3.46a4.21,4.21,0,0,0,.84,3.27,3.34,3.34,0,0,0,2.9.92,31,31,0,0,1,4.14.21c1.86.16,3.76.31,5.33.31a9.13,9.13,0,0,0,2.64-.28,2.61,2.61,0,0,0,1.88-2.13,3.11,3.11,0,0,0-1.31-3,4.12,4.12,0,0,0-1.73-.63,5.38,5.38,0,0,1-1.19-.31,34.56,34.56,0,0,1-4.68-2.37c.27-1.51.72-4.53,1.17-7.72l-2,.52c-.5,3.42-1,6.49-1.16,7.46a.22.22,0,0,0,0,.08h0a.28.28,0,0,0,0,.09h0v.09h0a.28.28,0,0,1,0,.09h0s0,0,0,.08v0a.14.14,0,0,0,0,.06v0a.08.08,0,0,0,0,0l0,0,0,0a.08.08,0,0,1,0,0l0,0,0,.05,0,0,0,0,.05,0v0l.09.06a31.47,31.47,0,0,0,5.53,2.88,7.15,7.15,0,0,0,1.58.44,2.17,2.17,0,0,1,1,.31,1.2,1.2,0,0,1,.52,1.11.76.76,0,0,1-.58.6c-1.21.38-4.69.09-7.24-.12a33.67,33.67,0,0,0-4.47-.21A1.55,1.55,0,0,1,16,39.09a2.33,2.33,0,0,1-.35-1.69v0l.41-3.48a21.5,21.5,0,0,0-.42-7,14.23,14.23,0,0,1-.28-2Z",
    style: {
      fill: "#9d9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.46,21.08a27.23,27.23,0,0,1,1.18-5.48,1,1,0,0,0-.1-.83,1,1,0,0,0-.71-.43s-1.57-.17-3.69-.65l0,2c.93.2,1.74.34,2.34.43a30.32,30.32,0,0,0-.72,3.26",
    style: {
      fill: "#9d9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.48,3.69,11.05.2A1,1,0,0,0,9.71.36,1,1,0,0,0,9.87,1.7l3.75,3",
    style: {
      fill: "#9d9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.07,24.68l7.72,7.19a2.51,2.51,0,1,0,3.54-3.55l-8.14-7.53",
    className: "appointment-types__type-svg-fill",
    style: {
      stroke: "#9d9c9c",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.19,3.68a11.59,11.59,0,0,0-4.32-.77H19a6.36,6.36,0,0,0-.87.06,11.64,11.64,0,0,0-2.86,22.19,1.11,1.11,0,0,1,.27.12,11.55,11.55,0,0,0,5.36.79A11.64,11.64,0,0,0,24.19,3.68ZM27.6,15a7.77,7.77,0,0,1-10.66,6.71l-.18-.08A7.72,7.72,0,0,1,19.82,6.76h0a7.49,7.49,0,0,1,2.62.41A7.79,7.79,0,0,1,27.6,15Z",
    className: "appointment-types__type-svg-fill",
    style: {
      stroke: "#9d9c9c",
      strokeMiterlimit: 10,
      strokeWidth: "1.5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysiotherapy);
export default __webpack_public_path__ + "static/media/physiotherapy.edb0df33dab5ca1e3549b4887d88b736.svg";
export { ForwardRef as ReactComponent };